<!-- components/Survey/questions/InfoSlide.svelte -->
<script>
  import { fade } from 'svelte/transition';
  
  export let title = '';
  export let description = '';
  export let icon = null; // Keeping for compatibility
  
  // Split the title if it contains a colon
  let mainTitle = title;
  let benefitText = description;
  
  if (title.includes(':')) {
    const parts = title.split(':');
    mainTitle = parts[0];
    // If there's description content, use that, otherwise use what comes after the colon
    if (!description) {
      benefitText = parts[1].trim();
    }
  }
</script>

<div class="info-slide" in:fade={{duration: 300}}>
  <div class="content-wrapper">
    <div class="logo-container">
      <img src="https://cdn.nba.com/teams/uploads/sites/1610612739/2022/03/Asset-4-3.svg" alt="Cavs" class="logo" />
    </div>
    
    <div class="content">
      <h2 class="benefit-title">{mainTitle}</h2>
      <p class="benefit-description">{benefitText}</p>
      <div class="separator"></div>
    </div>
  </div>
</div>

<style>
  .info-slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .content-wrapper {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    padding: 2rem 1.5rem;
    background-color: white;
    border-radius: 8px;
  }
  
  .logo-container {
    margin-bottom: 2.5rem;
  }
  
  .logo {
    height: 50px;
    width: auto;
  }
  
  .content {
    margin-bottom: 1rem;
  }
  
  .benefit-title {
    font-size: 1.4rem;
    color: #333;
    margin-bottom: 1rem;
    font-weight: 700;
    line-height: 1.3;
  }
  
  .benefit-description {
    font-size: 1.4rem;
    color: #333;
    line-height: 1.5;
    margin-bottom: 2rem;
    font-weight: 400;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .separator {
    width: 80px;
    height: 4px;
    background-color: #BB945C; /* Cavs gold color */
    margin: 0 auto;
  }
  
  @media (max-width: 768px) {
    .content-wrapper {
      padding: 1.5rem 1rem;
    }
    
    .logo {
      height: 40px;
    }
    
    .benefit-title {
      font-size: 1.3rem;
    }
    
    .benefit-description {
      font-size: 1.2rem;
    }
  }
</style>